export enum TransactionStatusEnum {

    INITIATED = "INITIATED",
    AWAITING_CONFIRMATION = "AWAITING_CONFIRMATION",
    CANCELLED = "CANCELLED",
    PAID = "PAID",
}
export enum ScenarioStatus {

    STARTED = "STARTED",
    COMPLETED = "COMPLETED",
    CANCELLED = "CANCELLED",
}